'use strict';
import './mobile-home.scss';
import React, { useEffect, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import GenericStep from 'app/modules/journey/ui/containers/step-generic/step-generic';
import { loading, failure, success, RD, SRD } from 'srd';
import MobilePanel from 'app/shared/components/mobile/mobile-panel/mobile-panel';
import { isNull } from 'lodash';
import AllowCookiesPanel from 'app/shared/components/allow-cookies-panel/allow-cookies-panel';
import MobileInterstitiel from 'app/shared/components/mobile/mobile-interstitiel/mobile-interstitiel';
import MobileOptions from 'app/shared/components/mobile/mobile-options/mobile-options';
import { buildSteps } from 'app/modules/journey/service/step.service';
import { isEndStep, isTooEarlyStep, nbShowStepActions } from 'app/modules/journey/service/store/step.selector';
import { openDocument, openPageMarketing } from 'app/modules/corporate/service/corporate.service';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { AlertDanger } from 'app/shared/components/alert';
import MobileMarketing from 'app/modules/corporate/ui/containers/mobile/mobile-marketing/mobile-marketing';
import MobileOfferDetails from 'app/modules/corporate/ui/containers/mobile/mobile-offer-details/mobile-offer-details';
import { DidomiContext } from 'app/app';
import { DisplayMode } from 'app/modules/cms/model/marketing-campaign-models';

const MobileHome = () => {

  const didomi = useContext(DidomiContext);

  const dispatch = useDispatch();

  const marketingStore = useSelector((state: IRootState) => state.cms.marketing)
  const { spbLogoUrl } = useSelector((state: IRootState) => state.cms.marketing)
  const pageMarketing = useSelector((state: IRootState) => state.offers.pageMarketing)
  const selectedOffer = useSelector((state: IRootState) => state.offers.selectedOffer)
  const isReadyConfigStore = useSelector((state: IRootState) => state.config.isReady)
  const languagesList = useSelector((state: IRootState) => state.config.languages)
  const productCode = useSelector((state: IRootState) => state.config.productCode)
  const listSteps = useSelector((state: IRootState) => state.step.journeyStepsList);
  const stepLength = useSelector(nbShowStepActions);
  const endStep = useSelector(isEndStep);
  const _isTooEarlyStep = useSelector(isTooEarlyStep);


  const [mobileHomeSRD, setMobileHomeSRD] = React.useState<RD<string, number>>(loading())

  useEffect(() => {
    if (stepLength > 1) {
      setMobileHomeSRD(success(0));
    }
  }, [listSteps])

  const handleOpenDocument = (url, type) => {
    dispatch(openDocument(url, type));
  }

  const handleMarketingNavigation = () => {

    dispatch(gtmEvent('Interstitiel mobile', 'pop-up interstitiel', '0'))
    dispatch(openPageMarketing('MarketingNavigation'))
    // TODO dispatch({ type: UPDATE_STEP, payload: { previousStep: stepStore.currentStep, currentStep: stepLength - 1 } })
  }

  const handlePanelNavigation = () => {
    if (selectedOffer) {
      dispatch(gtmEvent('Panier mobile', selectedOffer.code, '0'))
      dispatch(openPageMarketing('PanelNavigation'))
    }
  }

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <div className="app-loading"><div className="lds-dual-ring"></div></div>,
    failure: (e) => <AlertDanger><span>{"Une erreur s'est produite"}</span>{e && <span> :<br />{e}</span>}</AlertDanger>,
    success: (num) =>
      <div id="App">
        <div className="mobileHeader">
          {/* {<MobileOptions didomi={didomi} spbLogoUrl={marketingStore.spbLogoUrl} offerSku={selectedOffer.code} handleOpenDocument={handleOpenDocument} languagesList={languagesList} />} */}
          {productCode &&
            <MobileOptions
              didomi={didomi}
              spbLogoUrl={marketingStore.spbLogoUrl}
              offerSku={selectedOffer?.code}
              handleOpenDocument={handleOpenDocument}
              languagesList={languagesList}
              productCode={productCode}
            />}
          {!isNull(marketingStore.productLogoUrl) && <img className="productLogo" src={marketingStore.productLogoUrl} alt="cover" />}

          {/* TODO: nbOffers */}
          {/* div empty essentielle pour center le logo quand le panier est sélectionné */}
          {!pageMarketing && !_isTooEarlyStep && (productCode !== 850) ? <MobilePanel nbOffers={endStep ? 0 : 1} handlePanelNavigation={handlePanelNavigation} /> : <div></div>}
        </div>
        <div className="mobileLayoutBox">
          <div className="mobileLayoutOverflow">
            {!pageMarketing && <GenericStep />}
            {pageMarketing === "PanelNavigation" && <MobileOfferDetails />}
            {pageMarketing === "MarketingNavigation" && <MobileMarketing />}
            {!endStep && !pageMarketing && marketingStore?.marketingItems && marketingStore?.marketingItems[DisplayMode.INFO_POP_IN] && <MobileInterstitiel iconURL={marketingStore.iconURL} handleMarketingNavigation={handleMarketingNavigation} />}
          </div>
        </div>
        {/* <Footer didomi={didomi} spbLogoUrl={spbLogoUrl} productCode={productCode} /> */}

      </div>
  }, mobileHomeSRD)

  return view
}

export default MobileHome;
